import { useMutation, useQueryClient } from '@tanstack/react-query';
import { addRecipient, regenerateRecipient, revokeRecipient } from '../api/recipients.api';
import { teamKeys } from './team.keys';

/**
 * Shared Startup Profile recipient mutations: add a recipient (generates a
 * share link and emails it, MYN-41/54), revoke one's access immediately
 * (MYN-54/57), and regenerate a recipient's link (new token, re-sent invite,
 * MYN-57). Each refreshes the recipients list on success.
 */
export function useRecipientActions(entityId: string) {
  const queryClient = useQueryClient();
  const invalidate = () =>
    queryClient.invalidateQueries({ queryKey: teamKeys.recipients(entityId) });

  const add = useMutation({
    mutationFn: ({ email, recipientName }: { email: string; recipientName: string }) =>
      addRecipient(entityId, { email, recipientName }),
    onSuccess: () => void invalidate(),
  });

  const remove = useMutation({
    mutationFn: (recipientId: string) => revokeRecipient(entityId, recipientId),
    onSuccess: () => void invalidate(),
  });

  const regenerate = useMutation({
    mutationFn: (recipientId: string) => regenerateRecipient(entityId, recipientId),
    onSuccess: () => void invalidate(),
  });

  return { add, remove, regenerate };
}
